import { useState, useMemo, useCallback } from 'react';

export const useFenceManagement = <T extends { id: string; name?: string }>(
    allItems: T[],
    itemsPerPage: number = 12
) => {
    const [currentPage, setCurrentPage] = useState(1);
    const [filter, setFilter] = useState('');

    // Filter
    const filteredItems = useMemo(() => {
        if (!filter) return allItems;
        return allItems.filter(item =>
            item.name?.toLowerCase().includes(filter.toLowerCase())
        );
    }, [allItems, filter]);

    // Pagination
    const paginatedItems = useMemo(() => {
        const start = (currentPage - 1) * itemsPerPage;
        return filteredItems.slice(start, start + itemsPerPage);
    }, [filteredItems, currentPage, itemsPerPage]);

    const totalPages = Math.ceil(filteredItems.length / itemsPerPage);

    // Handlers
    const handleSearchChange = useCallback((value: string) => {
        setFilter(value);
        setCurrentPage(1);
    }, []);

    const handlePageChange = useCallback((page: number) => {
        setCurrentPage(page);
    }, []);

    return {
        currentPage,
        filter,
        filteredItems,
        paginatedItems,
        totalPages,
        handleSearchChange,
        handlePageChange
    };
};
